import { render, staticRenderFns } from "./SDRecordList.vue?vue&type=template&id=8226de94&scoped=true&"
import script from "./SDRecordList.vue?vue&type=script&lang=js&"
export * from "./SDRecordList.vue?vue&type=script&lang=js&"
import style0 from "./SDRecordList.vue?vue&type=style&index=0&id=8226de94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8226de94",
  null
  
)

export default component.exports